import React from "react";

type MonotoneGuideDetailThumbnailProps = {
  trackNumber: number;
  className?: string;
};

export const MonotoneGuideDetailThumbnail = (
  { trackNumber, className }: MonotoneGuideDetailThumbnailProps,
) => {
  return (
    <svg
      className={className}
      id="_レイヤー_2"
      data-name="レイヤー_2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 650.71 490.71"
    >
      <defs>
        <style>
          {`
            .detail-cls-1 {
              fill: transparent;
              stroke-width: .71px;
            }

            .detail-cls-1, .detail-cls-2 {
              stroke: #333;
              stroke-miterlimit: 10;
            }

            .detail-cls-3 {
              font-family: 'Noto Sans CJK JP', 'Noto Sans JP', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
              font-size: 123.33px;
              font-weight: 400;
              text-anchor: middle;
              dominant-baseline: middle;
            }

            .detail-cls-2 {
              fill: none;
              stroke-width: 19.84px;
            }
          `}
        </style>
      </defs>
      <g id="_レイヤー_1-2" data-name="レイヤー_1">
        <g>
          <line
            className="detail-cls-2"
            x1="465.15"
            y1="349.52"
            x2="465.15"
            y2="253.6"
          />
          <line
            className="detail-cls-2"
            x1="184.9"
            y1="253.6"
            x2="184.9"
            y2="349.52"
          />
          <path
            className="detail-cls-2"
            d="M431.66,349.52v-95.92c0-59.33-48.1-107.43-107.43-107.43s-107.43,48.1-107.43,107.43v95.92"
          />
          <text className="detail-cls-3" x="325.36" y="320.14">
            {trackNumber}
          </text>
        </g>
      </g>
    </svg>
  );
};
